import React from 'react';
import { PAPER_SIZE, PRINT_TYPES } from 'const';
import A4Invoice from './A4Invoice';
import A5Invoice from './A5Invoice';
import ThreeInchInvoice from './ThreeInchInvoice';
import PrintReport from './PrintReport';

const PrintDocument = (props) => {
    const { data, shop, paperSize = PAPER_SIZE.A4, type = PRINT_TYPES.SALE } = props;

    if (!data || !shop) return null;

    if (type === PRINT_TYPES.REPORT) {
        return <PrintReport {...props} />;
    }

    if (paperSize === PAPER_SIZE.THERMAL_80MM && type !== PRINT_TYPES.ESTIMATE) {
        return <ThreeInchInvoice {...props} />;
    }

    const isA5 =
        paperSize === PAPER_SIZE.A5_VERTICAL ||
        paperSize === PAPER_SIZE.A5_HORIZONTAL;

    if (isA5) {
        return <A5Invoice {...props} />;
    }

    return <A4Invoice {...props} />;
};

export default PrintDocument;
